/**
 * Player controller
 * Manages a programme play list
 */
import React, { Component } from 'react';
import Player from './Player';
import ProgrammeDetails from './ProgrammeDetails';
import ProgrammePlayNext from './ProgrammePlayNext';
import Isvg from 'react-inlinesvg';
import clic_play from '../img/icons/clic_play_error.svg';
import translate from './TranslateHOC';
import {
  PLAYER_STATE_ACTIVE,
  PLAYER_STATE_INACTIVE,
  PLAYER_STATE_END_MORE,
  PLAYER_STATE_END,
  PLAY_NEXT_DELAY_MS,
  PLAYER_OD,
  PLAYER_STATE_LOADING,
  VERIFY_AGE_DIALOG,
  ENTER_PIN_DIALOG,
  PC_STATE_ON,
  PLAYER_CONFIG_NO_LOAD,
  PLAYER_CONFIG_LOAD_ONLY,
  PLAYER_CONFIG_LOAD_PLAY,
  BASE_URL,
  localStorageIsChild,
} from '../constants';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import { bindActionCreators } from 'redux';
import VerifyAgeDialog from './parents/modals/VerifyAgeDialog';
import EnterPinDialog from './parents/modals/EnterPinDialog';
import { isCasting, iOS } from '../helpers';

class ProgrammePlayerController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playerState: PLAYER_STATE_INACTIVE,
      playList: {},
      moreList: {},
      timerAutoNext: null,
      redirect: false,
      triggerConfigLoad: PLAYER_CONFIG_LOAD_ONLY, // Default state is load only
      playerInitial: true,
    };
    this.handlePlayerStateChange = this.handlePlayerStateChange.bind(this);
    this.generatePlayList = this.generatePlayList.bind(this);
    this.playNext = this.playNext.bind(this);
    this.reActivate = this.reActivate.bind(this);
    this.checkRedirect = this.checkRedirect.bind(this);
    //this.handleWatch = this.handleWatch.bind(this);
    this.handleUnsuitable = this.handleUnsuitable.bind(this);
    this.handleWarningConfirm = this.handleWarningConfirm.bind(this);
    this.handleForgottenPIN = this.handleForgottenPIN.bind(this);
  }

  UNSAFE_componentWillMount = () => {
    // If this prog is flagged unsuitable then init player but not config load
    if (this.props.prog && this.props.prog.unsuitable === '1') {
      this.setState({ triggerConfigLoad: PLAYER_CONFIG_NO_LOAD });
    }

    // check for ?play in URL
    // if exists, then it must have
    // come from an autplay playlist
    // in which case, play the next video
    const queryStr = this.props.location.search;
    if (queryStr === `?play`) {
      if (
        this.props.prog &&
        this.props.prog.unsuitable === '1' &&
        !this.props.disablePlayBack
      ) {
        // Can't do this until we know the PIN Status
        this.handleUnsuitable(); // Force the PC UI open
      } else {
        this.setState({ triggerConfigLoad: PLAYER_CONFIG_LOAD_PLAY }); // Just load and autoplay
      }
    }
  };

  componentDidMount = () => {
    if (
      this.props.prog &&
      this.props.prog.id &&
      this.props.seriesProgs &&
      this.props.moreProgs
    ) {
      this.generatePlayList(
        this.props.prog.id,
        this.props.seriesProgs,
        this.props.moreProgs,
        this.props.moreLike
      );
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (this.props.curLang !== nextProps.curLang && this.state.timerAutoNext) {
      this.clearTimer();
    }
    if (
      this.state.playerState === PLAYER_STATE_END_MORE &&
      this.state.timerAutoNext === null &&
      nextProps.isAutoNext &&
      this.props.isAutoNext !== nextProps.isAutoNext &&
      Object.keys(this.state.playList).length > 0
    ) {
      // trigger countdown as wan't active before
      this.createTimer();
    }
  };

  componentWillUnmount = () => {
    if (this.state.timerAutoNext) {
      this.clearTimer();
    }
  };

  checkRedirect = () => {
    const { playList } = this.state;
    if (this.state.redirect && Object.keys(playList).length > 0) {
      const progLink = `/programme/${playList.id}?play`;
      return <Redirect to={progLink} />;
    }
  };

  clearTimer = () => {
    clearTimeout(this.state.timerAutoNext);
    this.setState({ timerAutoNext: null });
  };

  createTimer = () => {
    let timer = setTimeout(this.playNext, PLAY_NEXT_DELAY_MS);
    this.setState({ timerAutoNext: timer });
  };

  reActivate = () => {
    this.handlePlayerStateChange(PLAYER_STATE_ACTIVE);
  };

  playNext = () => {
    if (Object.keys(this.state.playList).length > 0) {
      this.setState({ redirect: true });
    }
  };

  generatePlayList = (currentID, seriesList, moreProgs, moreLike) => {
    seriesList = Object.keys(seriesList).map((key) => seriesList[key]);
    let index = -1,
      playList = {},
      moreList = {};
    for (var i = 0; i < seriesList.length; i++) {
      if (seriesList[i].id === currentID) {
        index = i;
      }
    }
    if (index < seriesList.length - 1) {
      playList = seriesList[index + 1]; // just chuck in the index+1 from seriesList
    }

    //moreLike is from the AI generated recommended programmes feed
    if(moreLike && Object.keys(moreLike).length > 0) {
      //add random more like prog if any
      moreList = moreLike[Math.floor(Math.random() * moreLike.length)];
    } else {
      //moreProgs is from 'other_progs_in_genres' in the programme feed
      if (moreProgs && Object.keys(moreProgs).length > 0) {
        //add a random more progs if any
        moreList = moreProgs[Math.floor(Math.random() * moreProgs.length)];
      }
    }

    this.setState({ playList });
    this.setState({ moreList });
  };

  handlePlayerStateChange = (newState) => {
    this.setState({ playerInitial: false }); // player has now done something, no longer in the very first initial state
    switch (newState) {
      case PLAYER_STATE_ACTIVE:
        this.setState({ playerState: newState });
        break;
      case PLAYER_STATE_LOADING:
        this.setState({ playerState: newState });
        break;
      case PLAYER_STATE_END:
        this.props.resetIsPlaying();
        if (!isCasting()) {
          // ignore when cordova and casting
          let newEndState =
            Object.keys(this.state.playList).length > 0 ||
            Object.keys(this.state.moreList).length > 0
              ? PLAYER_STATE_END_MORE
              : PLAYER_STATE_END;

          if (iOS()) {
            const playerInstance = document.getElementById('s4c-player');
            playerInstance.classList.remove('vjs-ios-fullscreen');
            document.body.classList.remove('ios-faux-fullscreen');
          }

          this.setState({ playerState: newEndState });
          if (
            this.props.isAutoNext &&
            this.state.timerAutoNext === null &&
            Object.keys(this.state.playList).length > 0
          ) {
            this.createTimer();
          }
        }
        break;
      default:
        break;
    }
  };

  handleUnsuitable() {
    this.setState({ playerInitial: true });
    this.setState({ playerState: PLAYER_STATE_INACTIVE });
    switch (this.props.parentControlState) {
      case PC_STATE_ON:
        this.props.show(ENTER_PIN_DIALOG, {
          handleConfirm: this.handleWarningConfirm,
          handleForgottenPIN: this.handleForgottenPIN,
        });
        break;
      default:
        this.props.show(VERIFY_AGE_DIALOG, {
          handleConfirm: this.handleWarningConfirm,
        });
        break;
    }
  }

  handleForgottenPIN() {
    window.console.log('handleForgottenPIN');
  }

  handleWarningConfirm() {
    this.setState({ triggerConfigLoad: PLAYER_CONFIG_LOAD_PLAY });
  }

  render() {
    const {
      prog,
      curLang,
      isAutoNext,
      stingSeries,
      stingProgramme,
      stingCat,
      advertsDisable,
      signed,
      progResume,
      myList,
      disablePlayBack,
      loginRedirect,
      auth,
      recommendationId,
    } = this.props;
    const autoState = isAutoNext ? 'auto-on' : 'auto-off';
    const title = prog.series_title ? prog.series_title : prog.programme_title;
    const subTitle = !prog.series_title ? prog.programme_title : '';
    const isUnsuitable =
      this.props.prog && this.props.prog.unsuitable === '1' ? true : false;

    let isChildLocked = false;

    if (localStorage.getItem(localStorageIsChild)) {
      isChildLocked =
        localStorage.getItem(localStorageIsChild) === 'N'
          ? false
          : isUnsuitable
          ? true
          : false;
    }

    let style = {};
    if (prog.thumbnail_url) {
      style = {
        backgroundImage: `url('${BASE_URL}amg/1920x1080/${prog.thumbnail_url}')`,
      };
    }

    return (
      <div
        className={`programme__player programme__player--${
          this.state.playerState
        } ${
          this.state.playerInitial
            ? 'programme__player--initial'
            : 'programme__player--persists'
        } programme__player--${autoState} ${
          !auth ? 'programme__player--error' : ''
        }`}
      >
        {this.checkRedirect()}

        {!auth && (
          <div className="playerOverlayContainer">
            <div className="playerOverlay playerOverlay--error" style={style}>
              <h2 className="playerOverlayTitle">{title}</h2>
              <h3 className="playerOverlaySubTitle">{subTitle}</h3>
              <div className="playerPlayOverlay">
                <Isvg className="icon" src={clic_play} />
              </div>
            </div>
          </div>
        )}

        {auth && !isChildLocked && (
          <div
            className={
              'player__wrapper--' +
              (this.state.playerState === PLAYER_STATE_END_MORE
                ? 'hidden'
                : 'visible')
            }
            aria-disabled={this.state.playerState === PLAYER_STATE_END_MORE}
          >
            {!disablePlayBack && !isChildLocked && (
              <Player
                prog={prog}
                progResume={progResume}
                curLang={curLang}
                type={PLAYER_OD}
                onChange={this.handlePlayerStateChange}
                isTriggerConfigLoad={
                  this.state.triggerConfigLoad !== PLAYER_CONFIG_NO_LOAD
                }
                isTriggerAutoPlay={
                  this.state.triggerConfigLoad === PLAYER_CONFIG_LOAD_PLAY
                }
                stingSeries={stingSeries}
                stingProgramme={stingProgramme}
                stingCat={stingCat}
                advertsDisable={advertsDisable}
                signed={signed}
                handlePlayerSubtitlesChange={
                  this.props.handlePlayerSubtitlesChange
                }
                handleSubtitlesLoaded={this.props.handleSubtitlesLoaded}
                recommendationId={recommendationId}
              />
            )}

            {this.state.playerState === PLAYER_STATE_END_MORE && (
              <ProgrammePlayNext
                items={this.state.playList}
                moreItems={this.state.moreList}
                clearTimer={this.clearTimer}
                close={this.reActivate}
                isAutoPlay={this.props.isAutoNext}
              />
            )}
          </div>
        )}

        {isChildLocked && auth && (
          <div className="playerOverlayContainer">
            <div className="playerOverlay playerOverlay--error" style={style}>
              <h2 className="playerOverlayTitle">{title}</h2>
              <h3 className="playerOverlaySubTitle">{subTitle}</h3>
              <div className="playerPlayOverlay">
                <Isvg className="icon" src={clic_play} />
              </div>
            </div>
          </div>
        )}

        <ProgrammeDetails
          prog={prog}
          handleUnsuitable={this.handleUnsuitable}
          signed={signed}
          history={this.props.history}
          myList={myList}
          disablePlayBack={disablePlayBack}
          loginRedirect={loginRedirect}
          updateSubtitleId={this.props.updateSubtitleId}
          subtitleId={this.props.subtitleId}
          toggleSigned={this.props.toggleSigned}
          isUnsuitable={isUnsuitable}
          isChildLocked={isChildLocked}
        />
        <VerifyAgeDialog contentWarnings={prog.content_warnings} />
        <EnterPinDialog contentWarnings={prog.content_warnings} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth.authenticated,
    isAutoNext: state.autoNext,
    parentControlState: state.parentControlState,
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    show: bindActionCreators(show, dispatch),
  };
};

export default translate(
  connect(mapStateToProps, mapDispatchToProps)(ProgrammePlayerController)
);
